import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20home%20gardening%20scene%20with%20a%20thriving%20Mimosa%20pudica%20plant%20in%20a%20beautiful%20ceramic%20pot%20on%20a%20wooden%20desk%20surrounded%20by%20gardening%20books%20and%20a%20notebook%20soft%20golden%20afternoon%20light%20streaming%20through%20a%20window%20creating%20a%20peaceful%20atmosphere%20lifestyle%20photography%20style%20warm%20earth%20tones%20cozy%20and%20inspiring%20composition&width=1800&height=600&seq=cta-mimosa-banner&orientation=landscape"
          alt="开始你的害羞草种植之旅"
          title="害羞草种植 - 行动号召"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/50"></div>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-3">
          准备好开始你的害羞草之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
          从一粒种子到一株会"害羞"的神奇植物，整个过程充满乐趣与惊喜。
          跟随我们的指南，在家轻松种出属于你的害羞草。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/zhongzhi-fangfa"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md font-medium text-sm md:text-base transition-colors cursor-pointer whitespace-nowrap"
          >
            查看种植指南
          </Link>
          <Link
            to="/category/changjian-wenti"
            className="bg-white/20 hover:bg-white/30 text-white border border-white/30 px-6 py-3 rounded-md font-medium text-sm md:text-base transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            解决常见问题
          </Link>
        </div>
      </div>
    </section>
  );
}